import React from 'react'
import { makeStyles } from '@material-ui/core'
import TextField from '@material-ui/core/TextField'
import { red } from '@material-ui/core/colors'

const useStyles = makeStyles(theme => {
  return {
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    }
  }

})

export default function Input(props){
  const { id, value, placeholder, change, error, keyDown } = props
  const classes = useStyles()

  return (
    <>
      <TextField
        id={id}
        label={placeholder}
        className={classes.textField}
        value={value}
        onChange={(e) => change(e, id)}
        onKeyDown={keyDown}
        autoFocus={id !== 'name'} // preventing page from scrolling to input when page is first loaded
        margin="normal" />
      <span style={{fontSize: 16, display: error ? 'block' : 'none', color: red[500]}}>{error}</span>
    </>
  )
}
